class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);

      
        try{
           var check_limit = 1000000000;
          if(Shopify.currency.active == 'USD'){
            check_limit = 31;
          }else if(Shopify.currency.active == 'SGD'){
              check_limit = 39;
          }
          document.getElementById('cart-notification').querySelector('form [name="checkout"]').style.display = 'none';
            fetch('/cart.js')
                      .then(response => response.json())
                      .then(cart => {
                        const subtotal = cart.total_price / 100; // Shopify returns cents
                        const checkoutBtn = document.getElementById('cart-notification').querySelector('form [name="checkout"]');
                        const ctasWrapper = checkoutBtn?.closest('.cart-notification__links');
                        document.getElementById('cart-notification').querySelector('form [name="checkout"]').style.display = 'block';
                        if (!checkoutBtn || !ctasWrapper) return;

                        // Remove any previous warning
                        removeWarning(ctasWrapper);

                        if (subtotal < check_limit) {
                          // Disable button
                          checkoutBtn.disabled = true;
                          checkoutBtn.style.opacity = 0.5;
                          checkoutBtn.style.pointerEvents = 'none';

                          // Show warning
                          showWarning(ctasWrapper, 'Your cart total must be minimum $'+(check_limit+1)+' to checkout.');
                        } else {
                          // Enable button
                          checkoutBtn.disabled = false;
                          checkoutBtn.style.opacity = 1;
                          checkoutBtn.style.pointerEvents = 'auto';
                        }
                      });

                  function showWarning(container, message) {
                    const existing = container.nextElementSibling;
                    if (!existing || !existing.classList.contains('popup-warning')) {
                      const warning = document.createElement('p');
                      warning.className = 'popup-warning';
                      warning.style.color = 'red';
                      warning.style.marginTop = '10px';
                      warning.style.fontSize = '14px';
                      warning.innerText = message;
                      container.insertAdjacentElement('afterend', warning);
                    }
                  }

                  function removeWarning(container) {
                    const next = container.nextElementSibling;
                    if (next && next.classList.contains('popup-warning')) {
                      next.remove();
                    }
                  }
        }catch(e){}
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
